import React from "react";

export default (props) => {
    const estilos = {
        zIndex: 1,
        borderBottom: "none",
        textAlign: props.alignRight ? "right" : props.alignCenter ? "center" : "left",
        verticalAlign: props.verticalAlign || "top",
        minWidth: props.minWidth,
        maxWidth: props.maxWidth || "fit-content",
        width: props.width,
        height: props.height,
        minHeight: props.minHeight,
        paddingLeft: props.alignRight ? 0 : 2,
        paddingRight: props.alignRight ? 0 : 2,
        color: props.color,
        backgroundColor: props.backgroundColor,
    };

    //stickyTop
    if (props.sticky) {
        estilos.position = "sticky";
        estilos.top = props.top || -1;
        estilos.boxShadow = "inset 0px -1px 1px 0px rgba(0,0,0,0.20)";
    }

    //stickyLeft
    if (props.stickyFirstColumn) {
        estilos.position = "sticky";
        estilos.left = props.left || 0;
        estilos.boxShadow = "inset 0px -1px 1px 0px rgba(0,0,0,0.20)";
    }

    return (
        <th
            className={props.acoes ? "table-actions" : ""}
            style={{
                ...estilos,
                ...props.style,
            }}
            colSpan={props.colSpan}
            rowSpan={props.rowSpan}
            title={props.title}
        >
            {props.children}
        </th>
    );
};
